import actionFactoryTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  voteProject: {
    profit: { },
    options: [],
    product: { status: 4 },
    rule: { },
    ticketNum: 0,
  },
  voteLoginProject: null,
  voteLogs: [],
};

export const reducer = (state, action) => {
  const { data } = action;
  const { isLogin } = data || { };
  switch (action.type) {
    case actionFactoryTypes.SET_VOTE_PROJECT:
      return isLogin ? { ...state, voteLoginProject: data.voteProject }
        : { ...state, voteProject: data.voteProject };
    case actionFactoryTypes.SET_VOTE_LOG:
      return { ...state, voteLogs: action.data };
    default:
      return state;
  }
};
